import App from '@/models/App'

export default class ShareDocument extends App {
    static get entity() {
        return 'ShareDocuments'
    }
    static fields() {
        return {
            documentId: this.attr(''),
            userId: this.attr(''),
            userName: this.attr(''),
            userProfileImage: this.attr(''),
            companyName: this.attr(''),
        }
    }
    static getByDocumentId(documentId) {
        return this.query().where('documentId', documentId).get()
    }
    static add(data) {
        this.insert({
            data: {
                documentId: data.documentId,
                userId: data.userId,
                userName: data.userName,
                userProfileImage: data.userProfileImage,
                companyName: data.companyName,
            },
        })
    }
    static apiConfig = {
        actions: {
            fetch(folderId, documentId) {
                return this.get(
                    `/folders/${folderId}/documents/${documentId}/shares`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            create(folderId, documentId, params) {
                return this.post(
                    `/folders/${folderId}/documents/${documentId}/shares`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroy(shareUserId, folderId, documentId) {
                return this.delete(
                    `/folders/${folderId}/documents/${documentId}/shares/${shareUserId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
